/**
 * Mills theme front-end: cart, PDP, forms, Smile loyalty, StackDiscounts, quiz subscription.
 */
jQuery(function ($) {
  "use strict";

  const CONST = {
    BREAKPOINT: 1024,
    HEADER_SCROLLED_COLLECTION: 0,
    HEADER_SCROLLED_DEFAULT: 1,
    COLLECTION_HEADER_SHOW_Y: 220,
    LAZY_SCROLL_Y: 100,
    LOADER_SHOW_DELAY_MS: 50,
    LOADER_HIDE_MS: 300,
    POPUP_SHOW_DELAY_MS: 50,
    POPUP_HIDE_MS: 300,
    GOTO_SCROLL_OFFSET: 80,
    GOTO_ANIM_MS: 1000,
    SUBS_API_BASE: "https://subs.millsforpets.com/api/admin",
    CART_ADD: "/cart/add.js",
    CART_CLEAR: "/cart/clear.js",
    CART_GET: "/cart.js",
    QUIZ_URL: "https://millsforpets.com/pages/quiz",
    CART_PROP_SUB: "חידוש",
    CART_PROP_DISCOUNT_NEXT: "הנחה בהזמנה הבאה",
    STICKY_OFFSET_TOP: 118,
    YARD_POLL_MS: 500,
    RESIZE_DEBOUNCE_MS: 150,
    INGREDIENT_ROW_PX: 234,
    LAZY_ONLOAD_DELAY_MS: 100,
    SMILE_IFRAME_POLL_MS: 500,
    SMILE_IFRAME_MAX_POLLS: 80,
    POINTS_REDEEM_OPEN: "מימוש נקודות",
    POINTS_REDEEM_CLOSE: "סגור",
    NO_WEIGHT_HOVER: "בחר משקל בבקשה",
    NO_WEIGHT_DEFAULT: "הוסף לעגלה",
  };

  const SMILE_IFRAME = {
    RTL_STYLE:
      "*{direction:rtl;} .no-zoom.w-100{width:100%!important;} .no-zoom{transform: unset !important;}",
    INPUT:
      "#SmileUIPanelContainer > div.frame-content > div > div > div.panel-container > div > div:nth-child(2) > div.px-2.mb-1.text-center > div > input",
    BUTTON:
      "#SmileUIPanelContainer > div.frame-content > div > div > div.panel-container > div > div:nth-child(2) > div.px-2.mb-1.text-center > button",
    DESC: "#SmileUIPanelContainer > div.frame-content > div > div > div.panel-container > div > div:nth-child(2) > div.card-description",
  };

  const MSG = {
    required: "יש למלא שדה זה",
    emailInvalid: "יש להזין כתובת אימייל נכונה",
    passwordMin: "הסיסמה צריכה להיות בת 6 תווים לפחות",
  };

  const SEL = {
    header: "#header",
    collectionHeader: "#collection-header",
    resultsStickyGoto: "#results-sticky-goto",
    resultsSidesLeft: "#results-sides-left",
    footer: "#footer",
    loader: "#loader-wrapper",
    miniCart: "#mini-cart",
    miniCartBg: "#mini-cart-bg",
    miniCartItems: "#mini-cart-items",
    cartCount: "#cart-count",
    miniCartSubtotal: "#miniCartSubtotal",
    addToCart: "#AddToCart",
    productForm: "#product-form-main",
    sealsubsTarget: "#sealsubs-target-element",
  };

  let device = $(window).width() < CONST.BREAKPOINT ? "mobile" : "comp";
  let lastDevice = device;
  let yardField;
  let yardButton;
  let yardValue = 0;
  let yardPollId = null;
  let yardRefLoading = false;
  let pointsIdInSmile;
  let maxPointsToRedeem = 0;
  let customerPoints = 0;
  let smileCustomer = false;
  let redeemed = false;
  let scrollTicking = false;
  let lazyDone = { img: false, lazy: false, pos: false };
  let smileUiPollCount = 0;

  const $w = $(window);
  const $doc = $(document);
  const $body = $("body");

  function axiosAvailable() {
    return (
      typeof axios !== "undefined" &&
      axios &&
      typeof axios.post === "function" &&
      typeof axios.get === "function"
    );
  }

  function jqueryValidateAvailable() {
    return typeof $.fn.validate === "function";
  }

  function stickInParentAvailable() {
    return typeof $.fn.stick_in_parent === "function";
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      const ctx = this;
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function getDevice() {
    return $w.width() < CONST.BREAKPOINT ? "mobile" : "comp";
  }

  function syncProductIngredientsWidth() {
    if (getDevice() !== "mobile") return;
    const $pi = $("#product-ingredients");
    if (!$pi.length) return;
    const n = $(".ingredient-wrapper").length;
    $pi.css("width", n * CONST.INGREDIENT_ROW_PX + "px");
  }

  function initProductSticky() {
    if (!stickInParentAvailable()) return;
    if (getDevice() !== "comp") return;
    if (!$("#product-sides-right").length) return;
    $(".prod-sticky").each(function () {
      const $el = $(this);
      if ($el.data("appStickyInit")) return;
      try {
        $el.stick_in_parent({ offset_top: CONST.STICKY_OFFSET_TOP });
        $el.data("appStickyInit", true);
      } catch (e) {}
    });
  }

  $w.on(
    "resize orientationchange",
    debounce(function () {
      device = getDevice();
      syncProductIngredientsWidth();
      if (device !== lastDevice) {
        lastDevice = device;
      }
      initProductSticky();
      if (stickInParentAvailable() && $(".prod-sticky").length) {
        try {
          $(document.body).trigger("sticky_kit:recalc");
        } catch (e) {}
      }
      bindNoWeightUi();
    }, CONST.RESIZE_DEBOUNCE_MS)
  );

  $.easing.jswing = $.easing.swing;
  $.extend($.easing, {
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b;
      return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
    },
  });

  jQuery.fn.isInViewport = function () {
    const $el = jQuery(this);
    const elementTop = $el.offset().top;
    const elementBottom = elementTop + $el.outerHeight();
    const viewportTop = $w.scrollTop();
    const viewportBottom = viewportTop + $w.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  function showLoader() {
    $(SEL.loader).show();
    setTimeout(function () {
      $(SEL.loader).addClass("show");
    }, CONST.LOADER_SHOW_DELAY_MS);
  }

  function hideLoader() {
    $(SEL.loader).removeClass("show");
    setTimeout(function () {
      $(SEL.loader).hide();
    }, CONST.LOADER_HIDE_MS);
  }

  function openPopup(target) {
    const $p = $("#popup-" + target);
    $p.show();
    setTimeout(function () {
      $p.addClass("show");
    }, CONST.POPUP_SHOW_DELAY_MS);
  }

  function closePopup(target) {
    const $p = $("#popup-" + target);
    $p.removeClass("show");
    setTimeout(function () {
      $p.hide();
    }, CONST.POPUP_HIDE_MS);
  }

  function slickAvailable() {
    return typeof $.fn.slick === "function";
  }

  function initSlick($el, options) {
    if (!$el.length || !slickAvailable()) return;
    if ($el.hasClass("slick-initialized")) return;
    $el.slick(options);
  }

  function runLazyBatches(fromObserver) {
    if (!fromObserver && $w.scrollTop() <= CONST.LAZY_SCROLL_Y) return;

    if (!lazyDone.img && $(".lazy-img").length) {
      lazyDone.img = true;
      $(".lazy-img").each(function () {
        const $img = $(this);
        const src = $img.attr("data-src");
        if (src) $img.attr("src", src);
      });
    }
    if (!lazyDone.lazy && $(".lazy").length) {
      lazyDone.lazy = true;
      $(".lazy").each(function () {
        const $el = $(this);
        const src = $el.attr("data-src");
        if (src) $el.css("background", "url(" + src + ")");
      });
    }
    if (!lazyDone.pos && $(".lazy-pos").length) {
      lazyDone.pos = true;
      $(".lazy-pos").each(function () {
        const $el = $(this);
        const src = $el.attr("data-src");
        const pos = $el.attr("data-pos");
        if (src) {
          $el.attr(
            "style",
            "background: url(" +
              src +
              "); background-position: " +
              pos +
              " !important"
          );
        }
      });
    }
  }

  if ("IntersectionObserver" in window) {
    const lazyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runLazyBatches(true);
          lazyObserver.disconnect();
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );
    const firstLazy = document.querySelector(
      ".lazy-img, .lazy, .lazy-pos"
    );
    if (firstLazy) lazyObserver.observe(firstLazy);
  }

  function runLazyOnload() {
    if ($(".lazy-onload").length) {
      setTimeout(function () {
        $(".lazy-onload").each(function () {
          const $el = $(this);
          const src = $el.attr("data-src");
          if (src) $el.css("background", "url(" + src + ")");
        });
      }, CONST.LAZY_ONLOAD_DELAY_MS);
    }
    if ($(".lazy-img-onload").length) {
      setTimeout(function () {
        $(".lazy-img-onload").each(function () {
          const $el = $(this);
          const src = $el.attr("data-src");
          if (src) $el.attr("src", src);
        });
      }, CONST.LAZY_ONLOAD_DELAY_MS);
    }
  }

  function onScrollFrame() {
    const y = $w.scrollTop();
    const $ch = $(SEL.collectionHeader);

    if ($ch.length) {
      if (y > CONST.HEADER_SCROLLED_COLLECTION) {
        $(SEL.header).addClass("scrolled");
      } else {
        $(SEL.header).removeClass("scrolled");
      }
      if (y > CONST.COLLECTION_HEADER_SHOW_Y) {
        $ch.addClass("show");
      } else {
        $ch.removeClass("show");
      }
    } else {
      if (y > CONST.HEADER_SCROLLED_DEFAULT) {
        $(SEL.header).addClass("scrolled");
      } else {
        $(SEL.header).removeClass("scrolled");
      }
    }

    const $sticky = $(SEL.resultsStickyGoto);
    if ($sticky.length) {
      if (
        $(SEL.resultsSidesLeft).isInViewport() ||
        $(SEL.footer).isInViewport()
      ) {
        $sticky.addClass("hide");
      } else {
        $sticky.removeClass("hide");
      }
    }

    runLazyBatches();
    scrollTicking = false;
  }

  $w.on("scroll", function () {
    if (scrollTicking) return;
    scrollTicking = true;
    if (window.requestAnimationFrame) {
      requestAnimationFrame(onScrollFrame);
    } else {
      setTimeout(onScrollFrame, 16);
    }
  });

  $(".goto").on("click", function () {
    const target = $(this).attr("data-target");
    const $t = $("#" + target);
    if (!$t.length) return;
    $("html,body").animate(
      { scrollTop: $t.offset().top - CONST.GOTO_SCROLL_OFFSET },
      CONST.GOTO_ANIM_MS,
      "easeInOutQuint"
    );
  });

  $body.on("click", ".open-popup", function () {
    openPopup($(this).attr("data-target"));
  });
  $body.on("click", ".close-popup", function () {
    closePopup($(this).attr("data-target"));
  });

  runLazyOnload();

  $body.on("click", ".step", function () {
    const el = $(this);
    const target = el.attr("data-target");
    el.siblings(".step").removeClass("active");
    el.addClass("active");
    el.parents(".on-right")
      .siblings(".on-left")
      .find(".step-image")
      .removeClass("active");
    el.parents(".on-right")
      .siblings(".on-left")
      .find(".step-image-" + target)
      .addClass("active");
  });

  $body.on("click", ".why-bullet", function () {
    if (device !== "comp") return;
    const el = $(this);
    const target = el.attr("data-target");
    el.siblings(".why-bullet").removeClass("active");
    el.addClass("active");
    el.parents(".text").siblings(".images").find(".image").removeClass("active");
    el.parents(".text")
      .siblings(".images")
      .find(".bullet-image-" + target)
      .addClass("active");
  });

  initSlick($("#testimonials"), {
    arrows: true,
    centerPadding: "60px",
    slidesToShow: 3,
    centerMode: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerPadding: "21px",
        },
      },
    ],
  });

  initSlick($("#footer-slider"), {
    arrows: false,
    slidesToShow: 5,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: "linear",
    pauseOnHover: false,
    pauseOnFocus: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  initSlick($("#why-ingredients"), {
    arrows: false,
    slidesToShow: 6,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: "linear",
    pauseOnHover: false,
    pauseOnFocus: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "80px",
        },
      },
    ],
  });

  const $homeSlider = $("#home-products-slider");
  if ($homeSlider.length) {
    initSlick($homeSlider, {
      arrows: true,
      slidesToShow: 4,
      dots: false,
      infinite: false,
      rtl: true,
      swipeToSlide: true,
      touchThreshold: 7,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
            swipeToSlide: false,
            touchThreshold: 5,
          },
        },
      ],
    });

    function filterProductsSlider() {
      const collectionTarget = $("#home-products-collections").attr("data-target");
      const tagTarget = $("#tags-" + collectionTarget).attr("data-target");
      $homeSlider.slick("slickUnfilter");
      $homeSlider.slick(
        "slickFilter",
        ".c-" + collectionTarget + ".t-" + tagTarget
      );
    }
    filterProductsSlider();

    $body.on("click", ".collections li", function () {
      const el = $(this);
      const target = el.attr("data-target");
      const url = el.attr("data-url");
      $(".collections li").removeClass("active");
      el.addClass("active");
      $(".tags").removeClass("active");
      $("#tags-" + target).addClass("active");
      $("#go-to-collection").attr("href", url);
      $("#go-to-collection-m").attr("href", url);
      $("#home-products-collections").attr("data-target", target);
      filterProductsSlider();
      $("#home-products-slider .lazy-img").each(function () {
        const $img = $(this);
        const src = $img.attr("data-src");
        if (src) $img.attr("src", src);
      });
    });

    $body.on("click", ".t-filter", function () {
      const el = $(this);
      const target = el.attr("data-target");
      el.siblings(".t-filter").removeClass("active");
      el.addClass("active");
      el.parents(".tags").attr("data-target", target);
      filterProductsSlider();
    });
  }

  if (device === "mobile" && $("#icons-strip-content").length) {
    initSlick($("#icons-strip-content"), {
      arrows: false,
      slidesToShow: 1,
      variableWidth: true,
      centerMode: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 6000,
      cssEase: "linear",
      rtl: true,
    });
  }

  if (device === "mobile" && $("#why-bullets-n-1").length) {
    const $wb = $("#why-bullets-n-1");
    initSlick($wb, {
      arrows: false,
      slidesToShow: 1,
      dots: true,
    });
    $wb.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        const imageNum = parseInt(nextSlide, 10) + 1;
        $("#why-images-n-1").find(".image").removeClass("active");
        $("#why-images-n-1")
          .find(".bullet-image-" + imageNum)
          .addClass("active");
      }
    );
  }

  if (device === "mobile" && $("#why-bullets-n-2").length) {
    const $wb2 = $("#why-bullets-n-2");
    initSlick($wb2, {
      arrows: false,
      slidesToShow: 1,
      dots: true,
    });
    $wb2.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        const imageNum = parseInt(nextSlide, 10) + 1;
        $("#why-images-n-2").find(".image").removeClass("active");
        $("#why-images-n-2")
          .find(".bullet-image-" + imageNum)
          .addClass("active");
      }
    );
  }

  if (device === "mobile" && $("#product-images-slider").length) {
    initSlick($("#product-images-slider"), {
      arrows: false,
      slidesToShow: 1,
      dots: true,
    });
  }

  syncProductIngredientsWidth();
  initProductSticky();

  if (!$(".sealsubs-container").length) {
    $(SEL.sealsubsTarget).css("min-height", "0");
  }

  $body.on("click", ".toggle-expand", function () {
    $(this).toggleClass("active");
    if (stickInParentAvailable()) {
      try {
        $(document.body).trigger("sticky_kit:recalc");
      } catch (e) {}
    }
  });

  $("#noteFlag").on("click", function () {
    $("#noteFlagToggle").toggleClass("active");
  });

  $("#points-redeem").on("click", function () {
    $("#toggle-my-expand").toggleClass("active");
    const $btn = $(this);
    if ($btn.text() === CONST.POINTS_REDEEM_OPEN) {
      $btn.text(CONST.POINTS_REDEEM_CLOSE);
    } else {
      $btn.text(CONST.POINTS_REDEEM_OPEN);
    }
  });

  $body.on("click", "#product-advantages-bullets .bullet", function () {
    $("#product-advantages-bullets .bullet").removeClass("active");
    $(this).addClass("active");
  });

  $body.on("click", "#faqs .faq", function () {
    $(this).toggleClass("active");
  });

  function bindNoWeightUi() {
    $(SEL.addToCart).off(".appNoWeight");
    if (getDevice() === "comp") {
      $(SEL.addToCart).on("mouseenter.appNoWeight", function () {
        if ($(this).hasClass("no-weight")) {
          $(this).text(CONST.NO_WEIGHT_HOVER);
        }
      });
      $(SEL.addToCart).on("mouseleave.appNoWeight", function () {
        if ($(this).hasClass("no-weight")) {
          $(this).text(CONST.NO_WEIGHT_DEFAULT);
        }
      });
    } else {
      $(SEL.addToCart).on("click.appNoWeight", function () {
        if ($(this).hasClass("no-weight")) {
          $(this).text(CONST.NO_WEIGHT_HOVER);
        }
      });
    }
  }
  bindNoWeightUi();

  function getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  async function createSubscriptionCustomer() {
    if (!axiosAvailable()) return null;
    const randomId =
      Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
    const res = await axios.post(CONST.SUBS_API_BASE + "/customer", {
      email: "mills_pre_sub_" + randomId + "@test.com",
    });
    return res.data.id;
  }

  async function createCustomer() {
    try {
      if (!axiosAvailable()) return;
      const customerId = await createSubscriptionCustomer();
      if (customerId == null) return;
      const productData = getSelectedProductData();
      const { quizData, formattedData } = getQuizData();
      const noteData = createSubscriptionNoteData(
        productData,
        formattedData,
        quizData.caloriesPerDay
      );

      await axios.post(
        CONST.SUBS_API_BASE + "/customerSub/" + customerId,
        noteData
      );
      if (typeof trackEvent !== "undefined") {
        trackEvent("funnel", "create_subscription_customer", {
          customer_id: customerId,
          product_data: productData,
          formatted_data: formattedData,
          quiz_data: quizData,
          note_data: noteData,
        });
      }
      return customerId;
    } catch (e) {
      console.error(e);
    }
  }

  function getSelectedProductData() {
    const calsText = $(".the-cals").text();
    const caloriesPerDay = parseInt(calsText, 10) || 0;
    const selectedProductDiv = $(".show.active .prod");
    const productId = selectedProductDiv.attr("product-id");
    const d = selectedProductDiv.data("variation1");
    const variantId = d && d.id != null ? d.id : "";
    const variantPrice =
      d && typeof d.price === "number" && isFinite(d.price) ? d.price : 0;
    const variantGrams = d && d.grams != null ? d.grams : 0;
    const variantTitle = d && d.name != null ? String(d.name) : "";

    const fullPrice = Math.round(variantPrice / 100);
    const dailyPrice = Math.round(variantPrice / 100 / 30);

    const handle = selectedProductDiv.attr("data-handle") || "";
    const productTitle = handle ? handle.split("-")[0] : "";

    return {
      caloriesPerDay,
      variant: {
        id: Number(variantId) || 0,
        handle,
        name: productTitle,
        grams: Number(variantGrams) || 0,
        price: fullPrice,
        priceDay: dailyPrice,
        pid: Number(productId) || 0,
        title: variantTitle,
        trialPrice: 0,
      },
      fullPrice,
      discountedPrice: parseFloat((fullPrice * 0.9).toFixed(1)),
    };
  }

  function formatMillsQuizData(sub) {
    if (
      window.MillsQuiz &&
      typeof window.MillsQuiz.formatMillsQuizData === "function"
    ) {
      return window.MillsQuiz.formatMillsQuizData(sub);
    }
    console.warn(
      "[application] MillsQuiz.formatMillsQuizData missing; load quiz-engine.js before application.js"
    );
    return {
      dogs: [
        {
          name: sub && sub.name ? sub.name : "",
          quizData: {
            sex: 0,
            age: sub && +sub.age ? +sub.age : 0,
            weight: sub && +sub.weight ? +sub.weight : 0,
            sirus: false,
            activity: 0,
            body: 1,
            allergy: "",
            protein: "",
            notes: "",
          },
        },
      ],
    };
  }

  function getQuizData() {
    const quizDataFromLocalStorage = window.MillsQuizEngine
      ? window.MillsQuizEngine.loadQuizDataFromFlat()
      : null;
    const formattedData = formatMillsQuizData(quizDataFromLocalStorage);
    const { name } = formattedData.dogs[0];
    const { quizData } = formattedData.dogs[0];
    const { sex } = quizData;
    const cals = parseInt($(".the-cals").text(), 10) || 0;

    return {
      quizData: {
        ...quizData,
        caloriesPerDay: cals,
      },
      formattedData,
      name,
      sex,
    };
  }

  function createSubscriptionNoteData(productData, formattedData, caloriesPerDay) {
    const startDate = getCurrentDate();

    return {
      discount: 0.9,
      interval: 1,
      doubleFood: false,
      status: "new-onboarding",
      dogs: [
        {
          avatar: 2,
          status: "active",
          quizData: formattedData.dogs[0].quizData,
          name: formattedData.dogs[0].name,
          sex: formattedData.dogs[0].quizData.sex,
          caloriesPerDay,
          variants: [productData.variant],
          isTrial: false,
          fullPrice: productData.fullPrice,
          trialPrice: 0,
          subPrice: productData.discountedPrice,
          noTrialFirstOrderPrice: productData.discountedPrice,
        },
      ],
      hkId: "0",
      startDate: startDate,
      last: "",
    };
  }

  function addToCartFail() {
    hideLoader();
  }

  function moneyParse(amount) {
    return "₪" + (amount / 100).toFixed(2).replace(".00", "");
  }

  function updateCartCount(count) {
    $(SEL.cartCount).text(count).attr("data-val", count);
  }

  function buildCartItem(cartItem, index) {
    let isSubscription = false;
    let subDiscountNum = "";

    if (Object.prototype.hasOwnProperty.call(cartItem, "properties")) {
      $.each(cartItem.properties, function (k, v) {
        if (k === CONST.CART_PROP_SUB) {
          isSubscription = true;
        } else if (k === CONST.CART_PROP_DISCOUNT_NEXT) {
          subDiscountNum = parseFloat(String(v).replace(/%/g, ""));
        }
      });
    }

    const imgUrl =
      cartItem.featured_image && cartItem.featured_image.url
        ? cartItem.featured_image.url
        : "";
    let item =
      "<div class='item' data-index='" + index + "'>" +
      "<div class='trash' data-cart-remove='" +
      (parseInt(index, 10) + 1) +
      "'>X</div>" +
      "<div class='img-wrapper'><img src='" +
      imgUrl +
      "' alt=''></div>" +
      "<div class='desc'><div>";

    if (cartItem.quantity > 1) {
      item +=
        "<h3>" +
        cartItem.product_title +
        " x <span class='d-i-b'>" +
        cartItem.quantity +
        "</span></h3>";
    } else {
      item += "<h3>" + cartItem.product_title + "</h3>";
    }
    item += "<p>" + cartItem.variant_title + "</p>";
    if (isSubscription === true) {
      item += "<p>תזכורת חודשית</p>";
    }
    item += "<div class='qty-price'><div class='qty'>";
    item +=
      "<input class='qty-input' type='number' min='1' value='" +
      cartItem.quantity +
      "' readonly>";
    item +=
      "<span class='qty-input-plus' data-cart-update='" +
      (parseInt(index, 10) + 1) +
      "' data-cart-quantity='" +
      (cartItem.quantity + 1) +
      "'><span class='line one'></span><span class='line two'></span></span>";
    item +=
      "<span class='qty-input-minus' data-cart-update='" +
      (parseInt(index, 10) + 1) +
      "' data-cart-quantity='" +
      (cartItem.quantity - 1) +
      "'><span class='line one'></span></span>";
    item += "</div>";

    if (isSubscription === true) {
      if (subDiscountNum !== "" && !isNaN(subDiscountNum)) {
        item +=
          "<p class='price'>₪" +
          (
            (cartItem.line_price / 100 / 100) *
            (100 - subDiscountNum)
          ).toFixed(2) +
          "</p>";
      } else {
        item +=
          "<p class='price'>₪" +
          (cartItem.line_price / 100).toFixed(2) +
          "</p>";
      }
    } else {
      item +=
        "<p class='price'>₪" +
        (cartItem.line_price / 100).toFixed(2) +
        "</p>";
      item += "</div>";
    }
    item += "</div></div></div></div>";
    return item;
  }

  function buildCart(itemsIds, itemsToAdd, subtotal) {
    $(SEL.miniCart).removeClass("empty-cart");
    $(SEL.miniCartItems).html(itemsToAdd);
    $(SEL.miniCartSubtotal).text(moneyParse(subtotal));
  }

  function destroyCart() {
    $(SEL.miniCart).addClass("empty-cart");
    $(SEL.miniCartItems).empty();
  }

  function renderMiniCartFromCart(cart) {
    updateCartCount(cart.item_count);
    $(SEL.miniCartItems).empty();
    const cartItems = cart.items;
    if (cartItems && cartItems.length > 0) {
      let itemsToAdd = "";
      const itemsIds = [];
      $.each(cartItems, function (index, cartItem) {
        itemsToAdd += buildCartItem(cartItem, index);
        itemsIds.push(cartItem.variant_id);
      });
      buildCart(itemsIds, itemsToAdd, cart.items_subtotal_price);
    } else {
      destroyCart();
    }
  }

  function openCart() {
    if (device === "mobile") {
      $("#side-menu").removeClass("show");
      $("#menu-button").removeClass("rotate");
      $("#gorgias-chat-container").addClass("d-none");
    }
    $(".toggle-cart").attr("data-state", "opened");
    $(SEL.miniCartBg).show();
    $(SEL.miniCart).addClass("show");
    setTimeout(function () {
      $(SEL.miniCartBg).addClass("show");
    }, CONST.POPUP_SHOW_DELAY_MS);
  }

  function closeCart() {
    $("#gorgias-chat-container").removeClass("d-none");
    $(".toggle-cart").attr("data-state", "closed");
    $(SEL.miniCartBg).removeClass("show");
    $(SEL.miniCart).removeClass("show");
    setTimeout(function () {
      $(SEL.miniCartBg).hide();
    }, CONST.POPUP_HIDE_MS);
  }

  function addToCartOk() {
    if (typeof obApi === "function") {
      obApi("track", "Add to cart");
    }
    $.getJSON(CONST.CART_GET, function (cart) {
      updatePointsMsgOnMiniCart(cart);
      if ($("#cart-wrapper").length > 0) {
        location.reload();
        return;
      }
      renderMiniCartFromCart(cart);
      openCart();
      hideLoader();
    });
  }

  $body.on("submit", SEL.productForm, function (e) {
    e.preventDefault();
    if ($(SEL.addToCart).hasClass("no-weight")) return false;

    if ($("[data-option='subscription']").hasClass("active")) {
      const resultsDualPayload =
        typeof window.MillsResultsGetSubscriptionCartPayload === "function"
          ? window.MillsResultsGetSubscriptionCartPayload()
          : null;
      if ($("#results-wrapper").length > 0 && resultsDualPayload === false) {
        alert("נא לבחור שני טעמים שונים למנוי 2×15 לפני המשך לרכישה.");
        return false;
      }
      if (
        $("#results-wrapper").length > 0 &&
        resultsDualPayload &&
        resultsDualPayload.items &&
        resultsDualPayload.items.length > 0
      ) {
        if (typeof gtag !== "undefined") {
          gtag("event", "continue_to_checkout", {
            event_category: "subscription_purchase",
          });
        }
        showLoader();
        $.ajax({
          type: "POST",
          url: CONST.CART_ADD,
          dataType: "json",
          data: { items: resultsDualPayload.items },
          success: function () {
            window.location.href = "/checkout";
          },
          error: addToCartFail,
        });
        return false;
      }
      if (typeof gtag !== "undefined") {
        gtag("event", "continue_to_checkout", {
          event_category: "subscription_purchase",
        });
      }
      showLoader();
      $.ajax({
        type: "POST",
        url: CONST.CART_ADD,
        dataType: "json",
        data: $(SEL.productForm).serialize(),
        success: function () {
          window.location.href = "/checkout";
        },
        error: addToCartFail,
      });
      return false;
    }

    let oneTimeLabel = "";
    const v1 = $(".show.active .prod").data("variation1");
    if (v1 && v1.qtyTitle) {
      oneTimeLabel = String(v1.qtyTitle).trim();
    }
    if (typeof gtag !== "undefined") {
      gtag("event", "continue_to_checkout", {
        event_category: "one_time_purchase",
        event_label: oneTimeLabel || "one_time",
      });
    }
    showLoader();
    $.ajax({
      type: "POST",
      url: CONST.CART_ADD,
      dataType: "json",
      data: $(SEL.productForm).serialize(),
      success: addToCartOk,
      error: addToCartFail,
    });
    return false;
  });

  sessionStorage.removeItem("goToQuiz");

  $body.on("click", "#quiz-results-add-2", function () {
    sessionStorage.setItem("goToQuiz", "yes");
    const resultsDualPayload =
      typeof window.MillsResultsGetSubscriptionCartPayload === "function"
        ? window.MillsResultsGetSubscriptionCartPayload()
        : null;
    if ($("#results-wrapper").length > 0 && resultsDualPayload === false) {
      alert("נא לבחור שני טעמים שונים למנוי 2×15.");
      sessionStorage.removeItem("goToQuiz");
      return false;
    }
    if (
      $("#results-wrapper").length > 0 &&
      resultsDualPayload &&
      resultsDualPayload.items &&
      resultsDualPayload.items.length > 0
    ) {
      showLoader();
      $.ajax({
        type: "POST",
        url: CONST.CART_ADD,
        dataType: "json",
        data: { items: resultsDualPayload.items },
        success: function () {
          window.location.href = CONST.QUIZ_URL;
        },
        error: function () {
          hideLoader();
          sessionStorage.removeItem("goToQuiz");
          addToCartFail.apply(this, arguments);
        },
      });
      return false;
    }
    const variantId = $("#results-buy-wrapper-variation-id").val();
    if (typeof CartJS !== "undefined" && CartJS.addItem) {
      CartJS.addItem(variantId);
    }
  });

  function parseSubQuery() {
    const q = window.location.search;
    if (!q.includes("?sub=")) return null;
    const part = q.split("&endsub")[0];
    const eq = part.indexOf("=");
    if (eq === -1) return null;
    const raw = part.slice(eq + 1);
    if (!raw) return null;
    const ids = [];
    const qty = [];
    raw.split("_").forEach(function (param) {
      const idQty = param.split("-");
      ids.push(idQty[0]);
      qty.push(idQty[1]);
    });
    return { ids: ids, qty: qty };
  }

  const subFlow = parseSubQuery();
  if (subFlow) {
    showLoader();
    $.ajax({
      type: "POST",
      url: CONST.CART_CLEAR,
      dataType: "json",
      success: function () {
        addToCartItems(subFlow.ids, subFlow.qty);
      },
      error: addToCartFail,
    });
  }

  function addToCartItems(ids, qty) {
    const items = [];
    ids.forEach(function (item, i) {
      items.push({
        id: item,
        quantity: qty && qty.length ? qty[i] : 1,
      });
    });
    $.ajax({
      type: "POST",
      url: CONST.CART_ADD,
      data: { items: items },
      dataType: "json",
      success: addToCartOk,
      error: addToCartFail,
    });
  }

  function addToCartItem(id) {
    $.ajax({
      type: "POST",
      url: CONST.CART_ADD,
      data: { items: [{ id: id, quantity: 1 }] },
      dataType: "json",
      success: addToCartOk,
      error: addToCartFail,
    });
  }

  $body.on("click", ".toggle-cart", function () {
    const state = $(this).attr("data-state");
    if (state === "closed") openCart();
    else closeCart();
  });
  $body.on("click", ".open-cart", openCart);
  $body.on("click", ".close-cart", closeCart);

  $doc.on("cart.requestStarted", function () {
    showLoader();
  });

  $doc.on("cart.requestComplete", function (event, cart) {
    if ($("#cart-wrapper").length > 0) {
      location.reload();
      return;
    }

    if ($("#results-wrapper").length > 0) {
      const goToQuiz = sessionStorage.getItem("goToQuiz");
      sessionStorage.removeItem("goToQuiz");
      if (goToQuiz === "yes") {
        window.location.href = CONST.QUIZ_URL;
        return;
      }
      renderMiniCartFromCart(cart);
      updatePointsMsgOnMiniCart(cart);
      openCart();
      hideLoader();
      return;
    }

    renderMiniCartFromCart(cart);
    updatePointsMsgOnMiniCart(cart);
    openCart();
    hideLoader();
  });

  $(".toggle-login-reset").on("click", function () {
    $("#view-login").toggleClass("active");
    $("#view-reset").toggleClass("active");
  });

  function openMenu() {
    $("#side-menu-bg").show();
    $("#side-menu").addClass("show");
    setTimeout(function () {
      $("#side-menu-bg").addClass("show");
    }, CONST.POPUP_SHOW_DELAY_MS);
  }

  function closeMenu() {
    $("#side-menu-bg").removeClass("show");
    $("#side-menu").removeClass("show");
    setTimeout(function () {
      $("#side-menu-bg").hide();
    }, CONST.POPUP_HIDE_MS);
  }

  $body.on("click", ".open-menu", openMenu);
  $body.on("click", ".open-menu-shop", function () {
    $(".switch-menu").removeClass("active");
    $(".switch-menu[data-target='shop']").addClass("active");
    $("#side-menu-info").addClass("go-out");
    $("#side-menu-shop").removeClass("go-out");
    openMenu();
  });
  $body.on("click", ".open-menu-info", function () {
    $(".switch-menu").removeClass("active");
    $(".switch-menu[data-target='info']").addClass("active");
    $("#side-menu-shop").addClass("go-out");
    $("#side-menu-info").removeClass("go-out");
    openMenu();
  });
  $body.on("click", ".close-menu", closeMenu);

  $body.on("click", ".switch-menu", function () {
    $(".switch-menu").removeClass("active");
    $(this).addClass("active");
    const target = $(this).attr("data-target");
    if (target === "shop") {
      $("#side-menu-info").addClass("go-out");
      setTimeout(function () {
        $("#side-menu-shop").removeClass("go-out");
      }, 260);
    } else {
      $("#side-menu-shop").addClass("go-out");
      setTimeout(function () {
        $("#side-menu-info").removeClass("go-out");
      }, 260);
    }
  });

  $body.on("click", ".toggle-menu-item", function () {
    const el = $(this);
    const state = el.attr("data-state");
    if (state === "closed") {
      $("#side-menu-shop li").removeClass("opened");
      $("#side-menu-shop li .toggle-menu-item").attr("data-state", "closed");
      el.attr("data-state", "opened");
      el.parents("li").addClass("opened");
    } else if (state === "opened") {
      el.attr("data-state", "closed");
      el.parents("li").removeClass("opened");
    }
  });

  $body.on("click", "#menu-button", function () {
    $("#side-menu").toggleClass("show");
    $("#menu-button").toggleClass("rotate");
    setTimeout(closeCart, 400);
  });

  $body.on("click", ".side-menu .menu .m-title", function () {
    $(this).parents(".menu").toggleClass("m-active");
  });

  const valMsgs = {
    contact: {
      "contact[first_name]": MSG.required,
      "contact[last_name]": MSG.required,
      "contact[phone]": MSG.required,
      "contact[email]": {
        required: MSG.required,
        email: MSG.emailInvalid,
      },
      "contact[body]": MSG.required,
    },
    newsletter: {
      email: {
        required: MSG.required,
        email: MSG.emailInvalid,
      },
    },
    login: {
      "customer[email]": {
        required: MSG.required,
        email: MSG.emailInvalid,
      },
      "customer[password]": MSG.required,
    },
    create: {
      "customer[first_name]": MSG.required,
      "customer[last_name]": MSG.required,
      "customer[email]": {
        required: MSG.required,
        email: MSG.emailInvalid,
      },
      "customer[password]": {
        required: MSG.required,
        minlength: MSG.passwordMin,
      },
    },
    resetPwd: {
      "customer[password]": {
        required: MSG.required,
        minlength: MSG.passwordMin,
      },
      "customer[password_confirmation]": {
        required: MSG.required,
        minlength: MSG.passwordMin,
      },
    },
  };

  if (jqueryValidateAvailable()) {
    if ($("#contact_form").length) {
      $("#contact_form").validate({ messages: valMsgs.contact });
    }
    if ($("#newsletter-form").length) {
      $("#newsletter-form").validate({ messages: valMsgs.newsletter });
    }
    if ($("#customer_login").length) {
      $("#customer_login").validate({ messages: valMsgs.login });
    }
    if ($("#create_customer").length) {
      $("#create_customer").validate({
        rules: {
          "customer[password]": {
            required: true,
            minlength: 6,
          },
        },
        messages: valMsgs.create,
      });
    }
    if ($("#reset-customer-password").length) {
      $("#reset-customer-password").validate({
        rules: {
          "customer[password]": {
            required: true,
            minlength: 6,
          },
          "customer[password_confirmation]": {
            required: true,
            minlength: 6,
          },
        },
        messages: valMsgs.resetPwd,
      });
    }
  }

  $body.on("click", ".switch-to-reset", function () {
    $("#view-login").removeClass("active");
    setTimeout(function () {
      $("#view-login").hide();
      $("#view-reset").show();
    }, 450);
    setTimeout(function () {
      $("#view-reset").addClass("active");
    }, 500);
  });

  $body.on("click", ".switch-to-login", function () {
    $("#view-reset").removeClass("active");
    setTimeout(function () {
      $("#view-reset").hide();
      $("#view-login").show();
    }, 450);
    setTimeout(function () {
      $("#view-login").addClass("active");
    }, 500);
  });

  if ($("#customer_login").length) {
    if (window.location.href.indexOf("#") > -1) {
      const docUrl = document.URL;
      const docUrlHash = docUrl.substring(docUrl.indexOf("#")).substr(1);
      if (docUrlHash === "recover") {
        $("#view-login").removeClass("active");
        setTimeout(function () {
          $("#view-login").hide();
          $("#view-reset").show();
        }, 450);
        setTimeout(function () {
          $("#view-reset").addClass("active");
        }, 500);
      }
    }
  }

  function getSmileApi() {
    if (!window.Smile || typeof window.Smile !== "object") return null;
    if (
      window.Smile.legacySmile &&
      typeof window.Smile.legacySmile === "object"
    ) {
      return window.Smile.legacySmile;
    }
    if (
      window.Smile.newSmileSDK &&
      typeof window.Smile.newSmileSDK === "object"
    ) {
      return window.Smile.newSmileSDK;
    }
    return window.Smile;
  }

  function hasFn(obj, name) {
    return !!obj && typeof obj[name] === "function";
  }

  function toNumber(v, fallback) {
    if (fallback === undefined) fallback = 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  }

  function sleep(ms) {
    return new Promise(function (r) {
      setTimeout(r, ms);
    });
  }

  async function waitForSmile(timeoutMs) {
    if (timeoutMs === undefined) timeoutMs = 12000;
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      const s = getSmileApi();
      if (s) return s;
      await sleep(50);
    }
    return null;
  }

  async function ensureSmileCustomer() {
    const s = await waitForSmile();
    if (!s) return null;

    const customerLike = s.customer;

    if (customerLike && typeof customerLike === "object") {
      if (
        typeof customerLike.points_balance !== "undefined" &&
        customerLike.points_balance !== null
      ) {
        return customerLike;
      }
    }

    if (customerLike && hasFn(customerLike, "current")) {
      try {
        const cur = customerLike.current();
        if (cur && typeof cur === "object") {
          s.customer = cur;
          if (
            typeof s.customer.points_balance === "undefined" ||
            s.customer.points_balance === null
          ) {
            if (hasFn(s, "fetchCustomer")) {
              try {
                const fetched = await s.fetchCustomer();
                if (fetched && typeof fetched === "object") s.customer = fetched;
              } catch (e) {}
            }
          }
          return s.customer;
        }
      } catch (e) {}
    }

    if (hasFn(s, "fetchCustomer")) {
      try {
        const c = await s.fetchCustomer();
        if (c && typeof c === "object") {
          s.customer = c;
          return c;
        }
      } catch (e) {}
    }

    return s.customer && typeof s.customer === "object" ? s.customer : null;
  }

  async function safeFetchAllPointsProducts() {
    const s = await waitForSmile();
    if (!s || !hasFn(s, "fetchAllPointsProducts")) return [];
    try {
      const res = await s.fetchAllPointsProducts();
      return Array.isArray(res) ? res : [];
    } catch (e) {
      return [];
    }
  }

  async function safeFetchAllRewardFulfillments() {
    const s = await waitForSmile();
    if (!s || !hasFn(s, "fetchAllRewardFulfillments")) return [];
    try {
      const res = await s.fetchAllRewardFulfillments();
      return Array.isArray(res) ? res : [];
    } catch (e) {
      return [];
    }
  }

  async function safePurchasePointsProduct(pointsProductId, pointsToSpend) {
    const s = await waitForSmile();
    if (!s || !hasFn(s, "purchasePointsProduct")) return null;
    try {
      return await s.purchasePointsProduct(pointsProductId, {
        points_to_spend: pointsToSpend,
      });
    } catch (e) {
      return null;
    }
  }

  function fetchPoints() {
    const s = getSmileApi();
    if (!s || !s.customer) return;

    const balance = toNumber(s.customer.points_balance, 0);

    $("#points-value").empty().text(balance);
    $("#points-value-money").empty().text(
      "(₪" + (balance / 10).toFixed(1) + ")"
    );

    initPointsMsgOnMiniCart();
  }

  function setCustomerClubMsgNotEnoughPoints() {
    if (!$(".customer-club .low-button").hasClass("d-none")) {
      $(".customer-club .low-button").addClass("d-none");
    }
    $(".customer-club .msg").html(
      "🌟 אין לך מספיק נקודות למימוש."
    );
  }

  function setCustomerClubMsgNotEnoughCart() {
    if (!$(".customer-club .low-button").hasClass("d-none")) {
      $(".customer-club .low-button").addClass("d-none");
    }
    $(".customer-club .msg").html(
      "🌟 לא ניתן לממש נקודות בסכום זה."
    );
  }

  function setCustomerClubMsgReadyToRedeem(points) {
    if ($(".customer-club .low-button").hasClass("d-none")) {
      $(".customer-club .low-button").removeClass("d-none");
    }
    $(".customer-club .msg").html(
      '🌟 חסוך <strong><span id="points-value-cart">₪' +
        points +
        "</span></strong> במימוש נקודות."
    );
  }

  function initPointsMsgOnMiniCart() {
    if (!smileCustomer || redeemed) return;

    const s = getSmileApi();
    if (!s || !s.customer) return;

    customerPoints = toNumber(s.customer.points_balance, 0);
    maxPointsToRedeem = customerPoints;

    if (maxPointsToRedeem < 10) {
      setCustomerClubMsgNotEnoughPoints();
      return;
    }

    $.getJSON(CONST.CART_GET, function (cart) {
      if (!cart) return;

      let totalCartPrice = toNumber(cart.items_subtotal_price, 0) / 100;
      totalCartPrice -= toNumber(yardValue, 0);
      totalCartPrice = +(Math.round(totalCartPrice * 100) / 100).toFixed(2);

      if (totalCartPrice < maxPointsToRedeem / 10) {
        maxPointsToRedeem = totalCartPrice * 10;
      }

      if (maxPointsToRedeem / 10 < 10) {
        setCustomerClubMsgNotEnoughCart();
        return;
      }

      setCustomerClubMsgReadyToRedeem((maxPointsToRedeem / 10).toFixed(1));
    });
  }

  function updatePointsMsgOnMiniCart(cart) {
    if (!smileCustomer || !cart || redeemed) return;

    const s = getSmileApi();
    if (!s || !s.customer) return;

    customerPoints = toNumber(s.customer.points_balance, 0);
    maxPointsToRedeem = customerPoints;

    if (maxPointsToRedeem < 10) {
      setCustomerClubMsgNotEnoughPoints();
      return;
    }

    let totalCartPrice = toNumber(cart.items_subtotal_price, 0) / 100;
    totalCartPrice -= toNumber(yardValue, 0);
    totalCartPrice = +(Math.round(totalCartPrice * 100) / 100).toFixed(2);

    if (totalCartPrice < maxPointsToRedeem / 10) {
      maxPointsToRedeem = totalCartPrice * 10;
    }

    if (maxPointsToRedeem / 10 < 10) {
      setCustomerClubMsgNotEnoughCart();
      return;
    }

    setCustomerClubMsgReadyToRedeem((maxPointsToRedeem / 10).toFixed(1));
  }

  function fetchCodes(flag) {
    if (flag === undefined) flag = false;
    $("#my-codes").empty();

    safeFetchAllRewardFulfillments().then(function (codes) {
      (codes || []).forEach(function (item, index) {
        if (index > 2) return;
        if (item.code != null && item.used_at == null) {
          let points = (item.source_description || "").split(" ")[1] || "0";
          points = String(points).replace(/,/g, "");

          const html =
            "<div class='code-wrapper'>" +
            "<div class='code-title'>קופון ₪" +
            (toNumber(points, 0) / 10).toFixed(1) +
            "</div>" +
            "<div class='code-coupon' id='" +
            item.code +
            "'>" +
            item.code +
            "</div></div>";

          if (flag) $("#my-codes").append(html);
          else $("#my-codes").prepend(html);
        }
      });
    });
  }

  let smileBootInFlight = false;
  async function bootstrapSmileData() {
    if (smileBootInFlight) return;
    smileBootInFlight = true;
    try {
      const s = await waitForSmile();
      if (!s) return;

      const customer = await ensureSmileCustomer();
      if (!customer) return;

      smileCustomer = true;

      customerPoints = toNumber(customer.points_balance, 0);
      maxPointsToRedeem = customerPoints;

      fetchPoints();

      const pointsProducts = await safeFetchAllPointsProducts();
      if (
        pointsProducts &&
        pointsProducts.length > 0 &&
        pointsProducts[0] &&
        pointsProducts[0].id
      ) {
        pointsIdInSmile = pointsProducts[0].id;
      }

      fetchCodes();
    } finally {
      smileBootInFlight = false;
    }
  }

  $doc.on("smile-ui-loaded", function () {
    bootstrapSmileData();
  });

  $doc.on("smile-js-loaded", function () {
    bootstrapSmileData();
  });

  $doc.ready(function () {
    if (getSmileApi()) bootstrapSmileData();
  });

  $("#confirm-redeem").on("click", async function () {
    if (!maxPointsToRedeem) return;

    if (!pointsIdInSmile) {
      const pointsProducts = await safeFetchAllPointsProducts();
      if (
        pointsProducts &&
        pointsProducts.length > 0 &&
        pointsProducts[0] &&
        pointsProducts[0].id
      ) {
        pointsIdInSmile = pointsProducts[0].id;
      }
    }
    if (!pointsIdInSmile) return;

    const pointsToSpend = toNumber($("#points-to-redeem").val(), 0);
    if (!pointsToSpend) return;

    const purchase = await safePurchasePointsProduct(
      pointsIdInSmile,
      pointsToSpend
    );
    if (!purchase) return;

    fetchCodes(true);
    await ensureSmileCustomer();
    fetchPoints();
  });

  $("#confirm-redeem-cart").on("click", async function () {
    showLoader();

    if (!maxPointsToRedeem) {
      hideLoader();
      return;
    }

    if (!pointsIdInSmile) {
      const pointsProducts = await safeFetchAllPointsProducts();
      if (
        pointsProducts &&
        pointsProducts.length > 0 &&
        pointsProducts[0] &&
        pointsProducts[0].id
      ) {
        pointsIdInSmile = pointsProducts[0].id;
      }
    }

    if (!pointsIdInSmile) {
      hideLoader();
      return;
    }

    $.getJSON(CONST.CART_GET, async function (cart) {
      try {
        let totalCartPrice = toNumber(
          cart && cart.items_subtotal_price,
          0
        ) / 100;
        totalCartPrice -= toNumber(yardValue, 0);

        if (totalCartPrice < maxPointsToRedeem / 10) {
          maxPointsToRedeem = totalCartPrice * 10;
        }

        const purchase = await safePurchasePointsProduct(
          pointsIdInSmile,
          maxPointsToRedeem
        );
        const code =
          purchase &&
          purchase.reward_fulfillment &&
          purchase.reward_fulfillment.code
            ? purchase.reward_fulfillment.code
            : null;

        if (!code) {
          hideLoader();
          return;
        }

        if (yardField && yardButton) {
          yardField.val(code);
          yardButton.trigger("click");
        }

        redeemed = true;

        $(".customer-club").html(
          '<div class="msg">חסכת <strong>₪' +
            (toNumber(maxPointsToRedeem, 0) / 10).toFixed(1) +
            "</strong></div>" +
            '<div class="low-button ok"><i class="far fa-check-circle"></i></div>'
        );

        hideLoader();
      } catch (e) {
        hideLoader();
      }
    });
  });

  function stopYardPolling() {
    if (yardPollId != null) {
      clearInterval(yardPollId);
      yardPollId = null;
    }
  }

  function yardPollTick() {
    const sd = window.StackDiscounts;
    if (!sd || typeof sd.loading === "undefined") {
      stopYardPolling();
      return;
    }
    const cur = !!sd.loading;
    if (cur !== yardRefLoading) {
      if (yardRefLoading && sd.coupons && sd.discountsValue) {
        getUpdatedYardValue(sd.coupons, sd.discountsValue);
      }
      yardRefLoading = cur;
    }
  }

  function startYardPolling() {
    stopYardPolling();
    const sd = window.StackDiscounts;
    if (!sd) return;
    yardRefLoading = !!sd.loading;
    yardPollId = setInterval(yardPollTick, CONST.YARD_POLL_MS);
  }

  function findYardField() {
    if (!$(".stack-discounts-applied-discount").length) {
      setTimeout(findYardField, CONST.YARD_POLL_MS);
      return;
    }
    yardField = $("#coupons_stacker_input");
    yardButton = $("#coupons_stacker_add_button");
    if (!yardField.length || !yardButton.length) {
      setTimeout(findYardField, CONST.YARD_POLL_MS);
      return;
    }
    yardButton.off("click.appYard").on("click.appYard", function () {
      const sd = window.StackDiscounts;
      if (sd && sd.coupons && sd.discountsValue) {
        getUpdatedYardValue(sd.coupons, sd.discountsValue);
      }
    });
    startYardPolling();
    setTimeout(forceCodeCouponFromClub, 1000);
  }

  findYardField();

  function forceCodeCouponFromClub() {
    if (!smileCustomer) return;

    let myFlag = false;

    safeFetchAllRewardFulfillments().then(function (codes) {
      (codes || []).forEach(function (item) {
        if (myFlag) return;
        if (item.code != null && item.used_at == null) {
          if (yardField && yardButton) {
            yardField.val(item.code);
            yardButton.trigger("click");
            myFlag = true;
          }
        }
      });
    });
  }

  function getUpdatedYardValue(coupons, values) {
    if (!Array.isArray(coupons)) return;

    let newValue = 0;
    coupons.forEach(function (coupon) {
      const raw =
        values && values[coupon] ? values[coupon] : "₪0";
      newValue += +String(raw).replace(/[^d.]/g, "");
    });

    if (yardValue !== newValue) {
      yardValue = newValue;
      initPointsMsgOnMiniCart();
    }
  }

  function updateSubscriptionPrices(monthlyPrice, dailyPrice) {
    $("#subscription-monthly-price").text("₪" + monthlyPrice + " לחודש");
    $("#subscription-daily-price").text(
      "₪" + parseFloat(dailyPrice).toFixed(2) + " ליום"
    );
    const originalPrice = Math.round(parseFloat(monthlyPrice) / 0.9);
    $("#subscription-prices span:nth-child(2)").text("₪" + originalPrice);
  }

  jQuery(window).ready(function () {
    const q = window.location.search || "";
    if (q.indexOf("smile_deep_link=reward_fulfillment_details") !== -1) {
      if (!$("head style[data-app-smile-hide]").length) {
        $("head").append(
          '<style data-app-smile-hide="">#smile-ui-container {display: none;}</style>'
        );
      }
    }

    if (q.indexOf("?smile_referral_code=") !== -1) {
      if (!$("#temp-hide").length) {
        $("header").append(
          "<style id='temp-hide'>#smile-ui-container {display: none;}</style>"
        );
      }
      smileUiPollCount = 0;
      findSmileUi();
    }

    function injectSmileIframeRtlStyle(doc) {
      if (!doc || !doc.head) return;
      if (doc.querySelector("style[data-app-smile-rtl]")) return;
      const style = doc.createElement("style");
      style.setAttribute("data-app-smile-rtl", "1");
      style.textContent = SMILE_IFRAME.RTL_STYLE;
      doc.head.appendChild(style);
    }

    function findSmileUi() {
      const $iframe = $("#smile-ui-container iframe");
      if ($iframe.length) {
        editSmileUi();
        return;
      }
      smileUiPollCount += 1;
      if (smileUiPollCount > CONST.SMILE_IFRAME_MAX_POLLS) return;
      setTimeout(findSmileUi, CONST.SMILE_IFRAME_POLL_MS);
    }

    function editSmileUi() {
      const $iframe = $("#smile-ui-container iframe");
      if (!$iframe.length) return;
      const iframeEl = $iframe.get(0);
      let smileDocument = null;
      try {
        smileDocument = iframeEl.contentDocument;
      } catch (e) {
        return;
      }
      if (!smileDocument || !smileDocument.head) return;

      injectSmileIframeRtlStyle(smileDocument);

      const input = smileDocument.querySelector(SMILE_IFRAME.INPUT);
      const button = smileDocument.querySelector(SMILE_IFRAME.BUTTON);
      const textEl = smileDocument.querySelector(SMILE_IFRAME.DESC);

      if (input) input.setAttribute("placeholder", "כתובת המייל שלך");
      if (button) button.innerText = "שלחו לי קוד הנחה";

      if (textEl) findSmileUiDescription(textEl);

      $("#temp-hide").remove();
    }

    let smileDescStopper = 0;
    function findSmileUiDescription(el) {
      if (!el) return;
      if (!el.innerText.startsWith("Your friend")) {
        const name = el.innerText.split(" ")[0];
        el.innerText =
          name +
          " שלח/ה לכם מתנה! הכניסו את כתובת המייל שלכם לקבלת קוד ההנחה.";
      } else if (smileDescStopper < 4) {
        smileDescStopper++;
        setTimeout(function () {
          findSmileUiDescription(el);
        }, CONST.SMILE_IFRAME_POLL_MS);
      } else {
        el.innerText =
          "חברים שלכם שלחו לכם מתנה! הכניסו את כתובת המייל שלכם לקבלת קוד ההנחה.";
      }
    }
  });
});
